function validateFields(target, action) {
  var that = $(target);
  $('.js-form-group').removeClass('has-error');
  that.find('button[type="submit"]').prop('disabled', 'disabled');
  var data = new FormData(that[0]);
  data.append('action', action);

  $.ajax({
    url: ajaxurl,
    data: data,
    processData: false,
    contentType: false,
    type: 'POST',
    // beforeSend: function() {
    //     $('.js-progress').addClass('animated');
    // },
    success: function () {
      grecaptcha.execute();
    },
    error: function (xhr, status, error) {
      // console.log(xhr.responseJSON);
      Object.keys(xhr.responseJSON).map(function (key) {
        $('#' + key).parents('.js-form-group').addClass('has-error');
      });
      that.find('button[type="submit"]').prop('disabled', false);
      $('.js-error-msg').fadeIn();
      $('#js-body').velocity("scroll", { duration: 500, easing: [0.645, 0.045, 0.355, 1.000] });
      // $('.js-progress').removeClass('animated');
    }
  });
}

function submitStoreFinder() {
  var that = $('#js-form-store-finder'),
      input = that.find('.js-input'),
      redirect = that.data('target');

  var url = redirect + '/s/?q=' + input.val()
  window.location = url;
}

$(function () {
  $('#js-form-store-finder').on('submit', function (event) {
    console.log('here')
    event.preventDefault();
    submitStoreFinder();
  });
});